export const manfrediteOnboardingStepsRequestMock = {
    action: 'forward',
    payload: {
        first_name: 'Bartolomé',
        last_name: 'Sagunto'
    },
    "lang": "ES"
};
export const manfrediteOnboardingStepResponseMock = {
    data: {
        step: {
            name: 'input_full_name',
            payload: {
                first_name: 'Bartolomé',
                last_name: 'Sagunto'
            },
            actions: ['ONE', 'TWO'],
            context: {
                steps: ['input_full_name', 'input_headline_bio']
            }
        }
    },
    "message": "getManfrediteOnboardingStatus",
    "lang": "MOCK"
};
//# sourceMappingURL=manfredite-onboarding-step.mocks.js.map